import { render, staticRenderFns } from "./iconMyTeams.vue?vue&type=template&id=0f4c3c7a&"
import script from "./iconMyTeams.vue?vue&type=script&lang=js&"
export * from "./iconMyTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports